/**
 * Function to format outfit inspiration products URLs,
 * in order to convert the production URL from contentful into a relative path
 */
export const formatProductURL = (productURL) =>
  productURL.replace(
    /https:\/\/([a-z]{2}\.)?([a-z]{1,8}\.lululemon\.com)/g,
    ""
  );

/**
 * Function to get the unified IDs from the URL of the selected product,
 * in order to set the categoryUID and selectedProductUID
 */
export const extractUnifiedIDs = (url) => {
  if (!url) {
    return null;
  }
  /**
   * Need the two groups of the reg exp to get category and product unified ids
   * in the position 1 and 2 of an array.
   */
  const match = url.match(/p\/([a-z-A-Z0-9]+)\/([a-z-A-Z0-9]+)\/_\//);
  const [, categoryID, productId] = match || [];
  return [categoryID, productId];
};
